exports = module.exports = require("../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".enterprise-plugins{margin-left:0;padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/css-loader!./src/web/PluginList.css
// module id = 327
// module chunks = 0